module.exports = __webpack_public_path__ + "static/media/Stairs_Before.bdd401d6.jpg";